import queryString from "query-string";

export function prettifyData(data) {
	if (typeof (data) === "string") {
		// short/long-term dating, not short/long term dating
		const directReplacements = {
			"long_term_dating": "long-term dating",
			"short_term_dating": "short-term dating",
			"non_binary": "non-binary",
		};

		return directReplacements[data] || data.replace(/_/gi, " ");
	} else if (Array.isArray(data)) {
		// if the passed in parameter is an array, parse the values

		const prettifiedData = data.map((dataValue) => {
			return prettifyData(dataValue);
		});

		return prettifiedData.sort();
	} else {
		return data;
	}
}

export const getQuery = (query) => {
	if (!query || !window || !window.location || !window.location.search) {
		return "";
	}

	const queryValue = queryString.parse(window.location.search)[query];

	return queryValue ? queryValue.replace(/-/gi, " ") : "";
};



// WEBPACK FOOTER //
// ./src/analytics/util/helpers.js